import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useAuthFunctions } from "../hooks/useAuthFunctions";


const LoginLogoutButton = () => {
  const { user } = useSelector((state) => state.auth);
  const { handleLogout} = useAuthFunctions();
  if (user) return (
    <>
    <Link to="/profile" className="navlink w-nav-link">
      Profile
    </Link>
    <Link to="/" onClick={handleLogout} className="navlink w-nav-link">
      Logout
    </Link>
      </>
  );

  return (
    <Link to="/login" className="navlink w-nav-link">
      Login
    </Link>
  );
};

export default LoginLogoutButton;
